import React, {Component} from "react";
// import GeneralAnimations from '../utils/generalAnimations';
// import {TweenMax, Power2} from "gsap/TweenMax";

import UserContext from '../../utils/UserContext';
import {PERMISSIONS} from '../../utils/Request';

class pageDashboard extends Component {
	
	constructor(props){
		super(props)
		this.state  = {
			
		}
		
	}
	
	componentDidMount(){
		/*GeneralAnimations.prepareGeneralAnimations();
		setTimeout( GeneralAnimations.animateGeneralElements, 400);*/

	}

	render(){
		
		return(
			<UserContext.Consumer>
				{user => {
					return (
						<section className="page page-dashboard">
							<div className="page-main-container">
								<div className="page-title">
									<div className="container-left">
										<p className="font-h3 font-semibold font-uppercase font-black">PANEL DE STK DISTRIBUCIONES TECNOLOGICAS</p>
									</div>
								</div>
								{/*{(PERMISSIONS.canAdministrator(user))?(
									<div className="page-cards-container">
										<div className="card-container">
											<p className="font-p font-semibold">Valor Stock</p>
											<button className="button button-default font-p font-white font-center">Ver valor</button>
										</div>
									</div>
				        		):null}*/}
							</div>
						</section>
					)
				}}
			</UserContext.Consumer>
		);
	}
}





export default pageDashboard;




